

import { createSlice } from "@reduxjs/toolkit";

const initialState: any | null = null;

const categoresSessionSlice = createSlice({
  name: "categoresSession",
  initialState,
  reducers: {
    setCategoresSessionStore: (state: any | null, action: any | null) => {
      return action.payload;
    },
  },
});

export const { setCategoresSessionStore } = categoresSessionSlice.actions;

export default categoresSessionSlice.reducer;
